import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_material_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { materialId: number }): 
  Promise<{ result: { Id?: number, AllocationStrategyWorkflowId?: string, AllowReceiving?: boolean, ControllerTypeId?: number, Description?: string, HoursAllowedInAmbient?: number, IsFinishedGood?: boolean, IsFixedLength?: boolean, IsFixedWeight?: boolean, IsWip?: boolean, LookupCode?: string, ManufacturingCrewComplement?: number, ManufacturingMoveNotNeeded?: boolean, ManufacturingOrdersUseWorstExpirationDate?: boolean, ManufacturingPackagingReview?: boolean, ManufacturingPackagingReviewDayOfTheYear?: number, ManufacturingPackagingReviewFeedbackTresholdInDays?: number, MaterialCatalogId?: number, MaterialCatalogSourceMaterialId?: number, MaterialGroupId?: number, MinimumDatingSpan?: number, MobileSkipCountBack?: boolean, Name?: string, ProjectId?: number, ReceiveAsInactive?: boolean, ScanSerialOfAllPackageLevels?: boolean, ShelfLifeSpan?: number, SkipCycleCount?: boolean, StandardUnitsPerHour?: number, StatusId?: number, StorageCategoryRuleId?: number, StorageCategoryRule?: { Id?: number, Name?: string }, MaterialGroup?: { Id?: number, Name?: string } } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      materialId: number    }) {
        if(isNil($inParams.materialId)) {
          return true; 
        }
      return false;
    }
}
